<template>
	<div class="fullwidth">


		<div v-if="list.length==0" class="fullwidth center paddingt50">
			<img class="width200 autoheight automargin" mode="widthFix" src="@/assets/images/empty.png" />
		</div>
		
		<div class="fullwidth padding15">
			<block v-for="(item, index) in list" :key="index">
				<div class="padding10 marginb15 bg_fff radius10" >

					<div class="fullwidth">
						<img mode="widthFix" class="width18 height18 middle marginr5" src="@/assets/images/time.png" />
						<div class="size5 middle inline">{{item.createTimeDisplay}}</div>
					</div>
					<div class="fullwidth">
						<div class="size3 inline color_blue">{{ item.note }}</div>
					</div>
					<div class="  size5 color_red">
						变动量 {{ item.amount }}
					</div>
					<div v-if="!!item.bdhz==true" class="flex_row padding0">
						<div class="  size5 color3">
							前值{{ item.bdqz }}
						</div>
						<div class="bold  size5 color3">
							后值{{ item.bdhz }}
						</div>
					</div>

				</div>
				
			</block>
		</div>
		<uni-load-more :status="status" :icon-size="16" :content-text="contentText" />
	</div>
</template>

<script>
	import uniLoadMore from '@/components/uni-load-more/uni-load-more.vue';
	//
	//var app = getApp();

	export default {
		components: {
			uniLoadMore
		},
		data() {
			return {
				subject:"",
				
				indicatorDots: true,
				autoplay: true,
				interval: 2000,
				duration: 500,
				//------------------
				//{"id":911,"bdhz":"990.0","bdqz":"979.0","note":"取消订单退回现金券","createTime":1771917721,
				// "glid":"order_mm09lnk0WZ0Vtn","ip":null,"amount":"11.0","type":"cancel_order_refund_coupon_in",
				// "subject":"coupon","account":"Ulecmc24jsaQ03","payId":"","typeDisplay":"取消订单返还现金券收入",
				// "createTimeDisplay":"2026-02-24 15:22:01","subjectDisplay":"现金券","accountDisplay":"fore"}
				list: [],
				page: 1,
				totalPage: 0,
				status: 'more',
				adpid: '',
				contentText: {
					contentdown: '上拉加载更多',
					contentrefresh: '加载中',
					contentnomore: '没有更多'
				}
			};
		},
		onShareAppMessage() {
			return {
				title: '欢迎体验',
				path: '/pages/goods/list/list'
			}
		},
		onNavigationBarButtonTap(e) {
			this.$router.push({ path: '/' }); 
		},
		created() {
			//uniapp转vue后，onLoad() 参数来源变化：options → this.$route.query 或 this.$route.params
			var options=this.$route.query || {};
			this.subject=options.subject;
			// if(this.subject=='select_shop'){
			// 	window.$utils.uniapi.setNavigationBarTitle({ title:"选择附近的店铺" })
			// }else{
			// 	window.$utils.uniapi.setNavigationBarTitle({ title:"查找附近店铺" })
			// }

		},
		mounted() {
			
			//避免reLaunch错误
			this.page = 1;
			this.getLiushuiList();
		},
		onPullDownRefresh() {
			//this.getAdvList();
			this.page = 1;
			this.getLiushuiList();
			window.$utils.uniapi.stopPullDownRefresh();
		},
		onReachBottom() {
			this.status = this.page >= this.totalPage ? "nomore" : 'more';
			if (this.page < this.totalPage) {
				this.page++;
				this.getLiushuiList();
			}
		},
		methods: {
			
			getLiushuiList: function(params) {
				console.log("查询list");
				var that = this;
				var user = window.$utils.uniapi.getStorageSync("user") || {};
				if(!!user==false || typeof user.id=="undefined"){
					alert("请先登录");return;
				}

				if (typeof params == "undefined") {
					params = {};
				}
				params.subject = this.subject;

				that.$axios.request( {url: window.$config.url.getLiushuiList,  data: params })
					.then(res => {
						console.log(JSON.stringify(res),window.$config.resCode.SUCCESS);
						//if(!that.commonResponse(res))return;
						if(!!res.code==true && res.code==window.$config.resCode.SUCCESS){
							var list = res.data.list;
							//数据合并
							if (params.page > 1) {
								list = that.list.concat(list);
							}
							that.list = list;
							that.totalPage = res.data.totalPage;
							that.status = that.page>=that.totalPage?"nomore":'more';
							
						}else if(!!res.msg==true){
							window.$utils.uniapi.showToast({ title:res.msg,icon:"none" });
						}else{
							window.$utils.uniapi.showToast({ title:"不成功",icon:"none" });
						}
					})
					.catch(error => {
						console.log('完整错误信息:', error);
						console.log('请求URL:', error.config);
						console.log('响应头:', error.response);
						alert("不成功");
					});

			},

			selectShop(obj) {
				var id = obj.id;
				var name = obj.name;
				window.$utils.uniapi.setStorageSync('selectedShop', obj);
				
				//清理数据
				window.$utils.uniapi.removeStorageSync('cartGoodsList');
				
				//跳转
				console.log("selectShop finish to index");
				//uni.switchTab({ url:"/pages/tabbar/index/index" });
				window.$utils.uniapi.reLaunch({ url:"/pages/tabbar/index/index"  });
			},
			

			goDetail(e) {
				console.log(e);
				this.$router.push({path:"/goods_detail",query:{id:e.id}});
					
			},

			aderror(e) {
				console.log("aderror: " + JSON.stringify(e.detail));
			}
		}
	};
</script>

<style scoped>
	.banner {
		height: 180px;
		overflow: hidden;
		position: relative;
		background-color: #ccc;
	}

	.banner-img {
		width: 100%;
	}

	.banner-title {
		max-height: 42px;
		overflow: hidden;
		position: absolute;
		left: 15px;
		bottom: 15px;
		width: 90%;
		font-size: 16px;
		font-weight: 400;
		line-height: 21px;
		color: white;
		z-index: 11;
	}

	.uni-media-list-logo {
		width: 90px;
		height: 70px;
	}

	.uni-media-list-body {
		height: auto;
		justify-content: space-around;
	}

	.uni-media-list-text-top {
		height: 37px;
		font-size: 14px;
		overflow: hidden;
	}

	.uni-media-list-text-bottom {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}
</style>


// WEBPACK FOOTER //
// src/views/user/liushui_list.vue